import { isCustomerInMilitaryGroup } from "@vp/id.me-verification";
import { useEffect, useState } from "react";

const isCustomerInMilitaryGroupUtils = async (customerId: string): Promise<boolean> => {
  const inMilitaryGroup = await isCustomerInMilitaryGroup(customerId);
  return inMilitaryGroup;
};

export const useIsCustomerInMilitaryGroup = ({
  customerId,
  isIdMeEnabled,
  isSignedIn,
  recheck = false,
}: {
  customerId?: string;
  isIdMeEnabled: boolean;
  isSignedIn?: boolean;
  recheck: boolean;
}) => {
  const [shopperIsInMilitaryGroup, setShopperIsInMilitaryGroup] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const setIsCustomerInMilitaryGroupState = async () => {
      if (!customerId || !isIdMeEnabled || !isSignedIn) {
        setError(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const result: boolean = await isCustomerInMilitaryGroupUtils(customerId);
        setShopperIsInMilitaryGroup(result);
      } catch (err) {
        setShopperIsInMilitaryGroup(false);
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    setIsCustomerInMilitaryGroupState();
  }, [customerId, recheck, isIdMeEnabled, isSignedIn]);

  return { shopperIsInMilitaryGroup, loading, error };
};
